import '../css/Login.css';
import IslandLogo from '../assets/IslandClub.svg';
import React, { useState, useEffect } from 'react';
import Portal from './Portal';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { LoginContext, LoginContextProvider } from '../Contexts/LoginContext';
import LoadingSpinner from '../Components/LoadingSpinner';

function Login() {

    const [inputEmailText, setEmailInputText] = useState("");

    const [inputPasswordText, setPasswordInputText] = useState("");
    const [logionResponse, setLoginResponse] = React.useState(null);

    const navigate = useNavigate();

    const navigateToPortal = () => {
        // 👇️ navigate to /contacts
        navigate('/portal');
    };

    function close() {
        window.close();
    }

    return (

<LoginContextProvider value={{navigate}} navigation={navigate}>
            <LoginContext.Consumer>
                {context => (



                    <div className="App">
                    <img src={IslandLogo} alt='Logo' />
                    <div className='Form-Background'>
                        <p className='Form-Heading'>Member login</p>
                        <div className='inner'>
                            <div className='group'>
                                <label className='Form-Title'>Email</label>
                                <input placeholder='Mail Id' className="Form-Input" type='text' onInput={e => setEmailInputText(e.target.value)} value={inputEmailText} />
                            </div>
                            <div className='group'>
                                <label className='Form-Title'>Password</label>
                                <input placeholder='Password' className="Form-Input" type="password" onInput={e => setPasswordInputText(e.target.value)} value={inputPasswordText} />
                                
                            </div>

                            <label className='Form-Error'>{context.errorMessage}</label>

                            <button className="Form-Button" onClick={async () => {
                                await context.doLogin({email: inputEmailText, password: inputPasswordText});
                            }
                            }>Log In</button>
                            
                            <p className="Form-Bottom-Text">Forgotten your password? Head to your app to reset</p>
                        </div>
                    </div>
                    <button className="Form-Close-Button" onClick={close}>Close</button>
                    {context.isLoading ? <LoadingSpinner /> : <></>}
                </div>
                
                )}
                </LoginContext.Consumer>
                </LoginContextProvider>

        
    )
}
export default Login;







